// Pure step-tracking + last-message-merge helpers for the chat reducer
// (frontend/src/context/SolomonContext.jsx). SolomonContext.jsx is a .jsx
// file (real JSX in SolomonProvider's return) that the plain `node --test`
// runner cannot parse, so reducer-adjacent pure logic that needs a unit test
// lives here instead — the same pattern pendingFetch.js already established
// in this directory.

// Generic patch-merge used by the UPDATE_LAST_MESSAGE reducer case. Kept as
// its own export so a test can assert that a `done`-style patch (which never
// carries a `steps` key) leaves any accumulated steps untouched.
export function mergeMessagePatch(message, patch) {
  return { ...message, ...patch };
}

// Appends one tool-call step, skipping a step whose tool+query repeats the
// immediately preceding one — a `status: 'searching'` event firing again for
// the same in-flight call should not grow the list.
export function appendStep(steps, { tool, query } = {}) {
  const prev = Array.isArray(steps) ? steps : [];
  const nextTool = tool ?? null;
  const nextQuery = query ?? null;
  const last = prev[prev.length - 1];
  if (last && last.tool === nextTool && last.query === nextQuery) {
    return prev;
  }
  return [...prev, { tool: nextTool, query: nextQuery, at: Date.now() }];
}
